import { objHasEmptyProp } from "./objHasEmptyProp";

export const enableSave = (obj, isRequired: boolean = false) => {
  let enabled = false;
  if (!objHasEmptyProp(obj) && isRequired === true) {
    enabled = true;
  }

  if (isRequired === false) {
    enabled = true;
  }

  return enabled;
};
